import React, { Component } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../redux/root-action';
import AddAccountModal from './AddAccountModal';
import StrategyModal from './StrategyModal';
import YourAccountsModal from './YourAccountsModal';
import DeleteAccountModal from './DeleteAccountModal';
import AccountInfo from './AccountInfo';

const accountViewComponentMap: { [key: string]: any } = {
  ADD_ACCOUNT: AddAccountModal,
  STRATEGY_MODAL: StrategyModal,
  YOUR_ACCOUNTS: YourAccountsModal,
  DELETE_ACCOUNT_MODAL: DeleteAccountModal,
  ACCOUNT_INFO: AccountInfo,
};

class AccountModal extends Component<any, any> {
  render(): JSX.Element {
    const { currentView } = this.props;
    const AccountView = accountViewComponentMap[currentView];
    return <AccountView />;
  }
}

const mapStateToProps = ({ account }: any) => ({
  currentView: account.currentView,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
})(AccountModal);
